module.exports = "/images/vendor/flag-icon-css/flags/1x1/im.svg?ac0c825e76851b740da5ce261793a43e";